module.exports = __webpack_public_path__ + "assets1783936157458/img/shezhi.f0be7990.svg";